import clsx from 'clsx';
import { useLocation } from 'react-router';
import Navigation from '@/components/ui/Navigation';
import ImpersonationBanner from '@/components/ui/ImpersonationBanner';
import { useFunnelStore } from '@/store/funnelStore';
import { useSiteWideSettings } from '@/hooks/useSanityQuery';
import Banner from '../ui/Banner';

// Custom hook to check if current route should hide header
const useShouldHideHeader = () => {
  const location = useLocation();

  // Check if current path is an interstitial route
  const isInterstitialPage = location.pathname.startsWith('/interstitial');

  // You can extend this to check for other routes that should hide header
  // For example: location.pathname.startsWith('/fullscreen') || location.pathname.startsWith('/modal')

  return isInterstitialPage;
};

const Header = () => {
  const { isShowProgressBar } = useFunnelStore();
  const shouldHideHeader = useShouldHideHeader();
  const { data: siteSettings } = useSiteWideSettings();

  // Hide header based on route metadata
  if (shouldHideHeader) {
    return null;
  }

  return (
    <header className={clsx(isShowProgressBar && 'sticky z-[301] top-0 bg-paper')}>
      {siteSettings?.settings?.map((setting) =>
        setting._type === 'banner' ? <Banner key={setting._type} banner={setting} /> : '',
      )}
      <ImpersonationBanner />
      <Navigation />
    </header>
  );
};

export default Header;
